import React, { useCallback } from 'react';

import { useUpdateMyTeamMutation } from '@/graphql';
import { useTeam } from '@/providers/TeamProvider';
import { useSnackbar } from 'notistack';

import { AccountDisplayProps } from '../AccountPanel';
import { EditTeamName } from './EditTeamName';

interface SettingEditTeamNameProps extends AccountDisplayProps {}

export const SettingEditTeamName = ({
	popDisplayState,
}: SettingEditTeamNameProps) => {
	const { team, refetch, isLoading: teamLoading } = useTeam();
	const { mutateAsync: updateMyTeam, isLoading: submitting } =
		useUpdateMyTeamMutation();
	const { enqueueSnackbar } = useSnackbar();
	const save = useCallback(
		async (teamName) => {
			try {
				await updateMyTeam({
					input: {
						name: teamName,
					},
				});
			} catch (e) {
				enqueueSnackbar(
					'Something went wrong while updating the team name',
					{
						variant: 'error',
					},
				);
				return;
			} finally {
				refetch();
				popDisplayState();
			}
		},
		[enqueueSnackbar, popDisplayState, refetch, updateMyTeam],
	);

	const loading = teamLoading || submitting;

	return <EditTeamName name={team.name} loading={loading} onSave={save} />;
};
